export default __webpack_public_path__ + "241b1ab50b3cd06867ad9f4c8b3de8c4.png";